import { benefits } from '../../../mocks/vehicles';

export default function BenefitsSection() {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-16">
          <p className="text-gray-500 text-sm mb-2">Por Que Escolher a Drive With US</p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
            Sua Viagem Merece o<br />Melhor Serviço
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {benefits.map((benefit) => (
            <div
              key={benefit.id}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2 flex flex-col"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-[#1e3a8a]/10 rounded-xl mb-6">
                <i className={`${benefit.icon} text-3xl text-[#1e3a8a]`}></i>
              </div>

              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {benefit.title}
              </h3>

              <p className="text-gray-600 leading-relaxed mb-auto">
                {benefit.description}
              </p>

              {benefit.disclaimer && (
                <p className="text-xs text-gray-400 mt-4 pt-4 border-t border-gray-100">
                  * {benefit.disclaimer}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
